import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import '../../../css/Preferences/RequesterPreferences.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import arrowdown from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import deleteicon from '../../../Assets/NominateRequest/delete-icon.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import addicon from '../../../Assets/TruckVisits/Assets-Desktop/add-icon.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { GET_ALL_COMPANY_NAMES, SERVICE_PREFERENCES } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
import AddProfileModal from '../../Shared/GenericModalError';
class RequesterPreferences extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            RoleType: '',
            selectedRoleType: '',
            RoleTypedropdown: false,
            RoleTypedata: [],
            PartnerName: '',
            PreferredCompany: '',
            companyUserEmail: '',
            PreferredCompanydropdown: false,
            errorMessage: 'Preferred Company already exist.',
            PreferredCompanydata: [
            ],
            searchPreferredCompanylength: 0,
            PreferredCompanydataFound: [],
            HaulageCompanies: [
            ],
            CnFAgents: [
            ],
            showPreferredCompanyDiv: false,
            showAddOPtion: false,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    onClosePending = () => {
        this.setState({ hasOpenPending: false });
    };
    getCompanyList = (roleType) => {
        ApiCall(
            'GET',
            utilityBaseURL + GET_ALL_COMPANY_NAMES + `?role=${roleType}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({ PreferredCompanydata: apiData });
                }
            }
        });
    }
    addPreferencesPOST = () => {
        ApiCall(
            'POST',
            utilityBaseURL + SERVICE_PREFERENCES,
            {
                "dataList": [
                    {
                        "roleType": [
                            {
                                "dataList": [
                                    {
                                        "companyName": this.state.PreferredCompany,//"string",
                                        "userEmail": this.state.companyUserEmail,//"string"
                                    }
                                ],
                                "roleName": this.state.RoleType
                            }
                        ],
                        "service": "Nominate-Request"
                    }
                ],
                "roleName": this.state.RoleType,
                "roleType": "Requester"
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.setState({ PreferredCompany: '' });
                    this.setState({ showAddOPtion: false });
                    this.getPreferences();
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    addPreferencesPUT = (previousData) => {
        const v1 = this.state.PreferredCompany;
        const v2 = this.state.companyUserEmail;
        const obj = {
            "companyName": v1,
            "userEmail": v2
        }
        const data = previousData;
        data.push(obj);
        ApiCall(
            'PUT',
            utilityBaseURL + SERVICE_PREFERENCES,
            {
                "dataList": [
                    {
                        "roleType": [
                            {
                                "dataList": data,
                                "roleName": this.state.RoleType
                            }
                        ],
                        "service": "Nominate-Request"
                    }
                ],
                "roleName": this.state.RoleType,
                "roleType": "Requester"
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(apiData => {
            if (apiData.flag != -1) {
                if (apiData.flag == '500') {
                    console.log('I am 500!');
                    this.setState({ hasOpenPending: true });
                } else {
                    console.log('I am 200!');
                    this.setState({ PreferredCompany: '' });
                    this.setState({ showAddOPtion: false });
                    this.getPreferences();
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    addCompanyName(e) {
        e.preventDefault();
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=${this.state.selectedRoleType}&roleType=Requester`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    if (apiData.roleType.length === 0) {
                        this.addPreferencesPOST();
                    }
                    else if (this.state.selectedRoleType === "Haulage Company") {
                        let first = false;
                        apiData?.roleType?.every((name, index) => {
                            if ("Haulage Company" == name.roleName) {
                                this.addPreferencesPUT(name.dataList);
                                first = true;
                                return false;
                            }
                            return true
                        });
                        if (!first) {
                            apiData?.roleType?.every((name, index) => {
                                if ("Haulage Company" !== name.roleName) {
                                    this.addPreferencesPOST();
                                    return false;
                                }
                                return true
                            });
                        }
                    }
                    else if (this.state.selectedRoleType === "CnF Agent") {
                        let second = false;
                        apiData?.roleType?.every((name, index) => {
                            if ("CnF Agent" == name.roleName) {
                                this.addPreferencesPUT(name.dataList);
                                second = true;
                                return false;
                            }
                            return true
                        });
                        if (!second) {
                            apiData?.roleType?.every((name, index) => {
                                if ("CnF Agent" !== name.roleName) {
                                    this.addPreferencesPOST();
                                    return false;
                                }
                                return true
                            });
                        }
                    }
                }
            }
        });
    }
    getPreferencesHaulage = () => {
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=Haulage Company&roleType=Requester`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let filteredHaulageData = apiData?.roleType?.filter((name, index) => "Haulage Company" == name.roleName)
                    this.setState({
                        HaulageCompanies: filteredHaulageData,
                    })
                    console.log('serv pre--', apiData);
                }
            }
        });
    }
    getPreferencesCnF = () => {
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=CnF Agent&roleType=Requester`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let filteredCnFData = apiData?.roleType?.filter((name, index) => "CnF Agent" == name.roleName)
                    this.setState({
                        CnFAgents: filteredCnFData,
                    })
                }
            }
        });
    }
    getPreferences = () => {
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=${this.state.selectedRoleType}&roleType=Requester`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let filteredHaulageData = apiData?.roleType?.filter((name, index) => "Haulage Company" == name.roleName)
                    let filteredCnFData = apiData?.roleType?.filter((name, index) => "CnF Agent" == name.roleName)
                    if (this.state.selectedRoleType === 'CnF Agent') {
                        this.setState({
                            CnFAgents: filteredCnFData
                        })
                    } else if (this.state.selectedRoleType == "Haulage Company") {
                        this.setState({
                            HaulageCompanies: filteredHaulageData,
                        })
                    }
                }
            }
        });
    }
    deletePreferences = (companyName, email) => {
        ApiCall(
            'DELETE',
            utilityBaseURL + SERVICE_PREFERENCES,
            {
                "dataList": [
                    {
                        "roleType": [
                            {
                                "dataList": [
                                    {
                                        "companyName": companyName,//"string",
                                        "userEmail": email,//"string"
                                    }
                                ],
                                "roleName": this.state.selectedRoleType
                            }
                        ],
                        "service": "Nominate-Request"
                    }
                ],
                "roleName": this.state.selectedRoleType,
                "roleType": "Requester"
            },
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.getPreferences();
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    };
    componentDidMount = () => {
        this.getPreferencesCnF();
        this.getPreferencesHaulage();
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ RoleTypedropdown: false });
            this.setState({ PreferredCompanydropdown: false });
        }
    };
    RoleTypedata = [{ name: "Haulage Company", Partner: "Haulage Companies" }, { name: "CnF Agent", Partner: "CnF Agents" }]
    toggleDropdownRoleType = () => {
        this.setState({ RoleTypedropdown: !this.state.RoleTypedropdown });
    };
    changeRoleTypeRoleType = (event) => {
        const found = this.RoleTypedata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ RoleType: found.name, PreferredCompany: '' });
        this.getCompanyList(found.name);
        this.setState({ RoleTypedropdown: !this.state.RoleTypedropdown });
        if (found.name) {
            this.setState({ showPreferredCompanyDiv: true })
        }
        if (found.Partner == "Haulage Companies") {
            this.setState({
                PartnerName: 'Haulage Companies',
                selectedRoleType: 'Haulage Company'
            });
            document.getElementById('PreferencesReqCnfA').style.background = '#F7F7F7';
            document.getElementById('PreferencesReqCnfA').style.borderBottomColor = '#F7F7F7';
            document.getElementById('PreferencesReqHCompany').style.background = '#FFFFFF';
            document.getElementById('PreferencesReqHCompany').style.borderBottomColor = '#D42E12';
        }
        if (found.Partner == "CnF Agents") {
            this.setState({
                PartnerName: 'CnF Agents',
                selectedRoleType: 'CnF Agent'
            });
            document.getElementById('PreferencesReqHCompany').style.background = '#F7F7F7';
            document.getElementById('PreferencesReqHCompany').style.borderBottomColor = '#F7F7F7';
            document.getElementById('PreferencesReqCnfA').style.background = '#FFFFFF';
            document.getElementById('PreferencesReqCnfA').style.borderBottomColor = '#D42E12';
        }
    }
    changePreferredPartner = (event) => {
        if (event.target.innerText == "Haulage Companies") {
            this.setState({
                PartnerName: 'Haulage Companies',
                selectedRoleType: 'Haulage Company'
            });
            document.getElementById('PreferencesReqCnfA').style.background = '#F7F7F7';
            document.getElementById('PreferencesReqCnfA').style.borderBottomColor = '#F7F7F7';
            document.getElementById('PreferencesReqHCompany').style.background = '#FFFFFF';
            document.getElementById('PreferencesReqHCompany').style.borderBottomColor = '#D42E12';
        }
        if (event.target.innerText == "CnF Agents") {
            this.setState({
                PartnerName: 'CnF Agents',
                selectedRoleType: 'CnF Agent'
            });
            document.getElementById('PreferencesReqHCompany').style.background = '#F7F7F7';
            document.getElementById('PreferencesReqHCompany').style.borderBottomColor = '#F7F7F7';
            document.getElementById('PreferencesReqCnfA').style.background = '#FFFFFF';
            document.getElementById('PreferencesReqCnfA').style.borderBottomColor = '#D42E12';
        }
    }
    handleChangePreferredCompany = (e) => {
        this.setState({
            PreferredCompany: e.target.value,
            searchPreferredCompanylength: e.target.value.length
        });
        this.setState({ showAddOPtion: false })
    }
    toggleSearchPreferredCompany = (e) => {
        this.setState({ PreferredCompanydropdown: true });
    };
    changePreferredCompany = (event) => {
        const found = this.state.PreferredCompanydataFound.find((name) => {
            if (name.companyName === event.target.innerText) {
                return name
            }
        })
        this.setState({
            PreferredCompany: found.companyName,
            companyUserEmail: found.userEmail
        });
        this.setState({ PreferredCompanydropdown: !this.state.PreferredCompanydropdown });
        if (found.companyName) {
            this.setState({ showAddOPtion: true })
        }
    }
    searchCompanyName = () => {
        if (this.state.searchPreferredCompanylength > 0) {
            this.state.PreferredCompanydataFound = this.state.PreferredCompanydata.filter(i => i.companyName?.toLowerCase().startsWith(this.state.PreferredCompany?.toLowerCase()))
            this.toggleSearchPreferredCompany();
        } else {
            this.state.PreferredCompanydataFound = [];
        }
    }
    render() {
        return (
            <div class="PreferencesReqOutercolor">
                <MetaDecorator title={TitleDescription.preferencesTitle} description={TitleDescription.preferencesDescription} />
                <Header tilesFetched={() => { }} />
                <div class="PreferencesReqOuterDivcss">
                    <div id="PreferencesReqBoxDiv">
                        <nav class="PreferencesReqNavbar">
                            <div className="PreferencesReqNavbarName">
                                <small id="PreferencesReqNavbarText">Preferences</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="PreferencesReqMidPartition">
                            <div class="PreferencesReqMainDiv">
                                <div class="PreferencesReqInnerLeftDiv">
                                    <div class="PreferencesReqInnerHead">
                                        <small class="PreferencesReqHeadText">Select Your Preferred Partner</small>
                                    </div>
                                    <div class="PreferencesReqSelectDiv">
                                        <div class="PreferencesReqRoleDivCss">
                                            <small id="PreferencesReqInputDivHeading">Role Type</small>
                                            <div className="pass-wrapper" id="PreferencesReqInputDiv" >
                                                <Input
                                                    readOnly name="RoleType" class="input" placeholder="Select Role Type"
                                                    type="text" id="PreferencesReqInput_Css" value={this.state.RoleType}
                                                />
                                                <img id="PreferencesReqInput_img" src={this.state.RoleTypedropdown ? arrowup : arrowdown} onClick={this.toggleDropdownRoleType} />
                                            </div>
                                            {this.state.RoleTypedropdown && (
                                                <div class="PreferencesReqDropDownPosition" >
                                                    <div class="PreferencesReqDropDownCard" ref={this.container} >
                                                        {(this.RoleTypedata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeRoleType(index1)} id="PreferencesReqDropRowCss">
                                                                    <small class="" id="PreferencesReqDropDownText" >{name.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {this.state.showPreferredCompanyDiv &&
                                            < div class="PreferencesReqSearchDivCss">
                                                <small id="PreferencesReqInputDivHeading">Preferred Company</small>
                                                <div className="pass-wrapper" id="PreferencesReqInputDiv" >
                                                    <Input
                                                        class="input" placeholder="Select Company Name"
                                                        type="text" id="PreferencesReqInputSearch_Css" value={this.state.PreferredCompany}
                                                        onChange={this.handleChangePreferredCompany}
                                                    />
                                                    <img id="PreferencesReqInputSearch_img" onClick={this.searchCompanyName} src={search}></img>
                                                </div>
                                                {this.state.PreferredCompanydropdown && (
                                                    <div class="PreferencesReqDropDownPosition" >
                                                        <div class="PreferencesReqDropDownCard" ref={this.container} >
                                                            {(this.state.PreferredCompanydataFound.map((name, index) => {
                                                                return (
                                                                    <DropDownTable onClick={(index1) => this.changePreferredCompany(index1)} id="PreferencesReqDropRowCss">
                                                                        <small class="" id="PreferencesReqDropDownText" >{name.companyName} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                                {!this.state.showAddOPtion ?
                                                    <small class="PreferencesReqBoottomMessage">
                                                        Only those companies will be visible which are registered on Cargo Connect
                                                    </small>
                                                    :
                                                    <div class="PreferencesReqAddDiv">
                                                        <div class="PreferencesReqAddInnerDiv" onClick={(e) => { this.addCompanyName(e) }}>
                                                            <img class="mr-2" src={addicon} />
                                                            <small class="PreferencesReqAddText">Add</small>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="PreferencesReqInnerRightDiv">
                                    <div class="PreferencesReqInnerHeadRight">
                                        <small class="PreferencesReqHeadText">Your Preferred Partner</small>
                                    </div>
                                    <div>
                                        <div class="PreferencesReqOptionDiv">
                                            <div class="PreferencesReqOptions">
                                                <div id="PreferencesReqHCompany" onClick={this.changePreferredPartner}>
                                                    Haulage Companies
                                                </div>
                                                <div id="PreferencesReqCnfA" onClick={this.changePreferredPartner}>
                                                    CnF Agents
                                                </div>
                                            </div>
                                            {this.state.PartnerName === '' &&
                                                <div class="PreferencesReqInitialDiv">
                                                    <text class="PreferencesReqInitialDivText">Select your preference from the listing above</text>
                                                </div>
                                            }
                                            {this.state.PartnerName === 'Haulage Companies' &&
                                                <div>
                                                    <table class="PrefRTablecss">
                                                        {(this.state.HaulageCompanies?.map((company, index) => {
                                                            return (
                                                                (company.dataList)?.map((d1, i) => {
                                                                    return (<>
                                                                        <tr class="PrefRTableRow">
                                                                            <td class="PrefRTablecol1">{i + 1}</td>
                                                                            <td class="PrefRTablecol2">{d1.companyName}</td>
                                                                            <td class="PrefRTablecol3" >
                                                                                <img class="PreferencesReqDelete_img" src={deleteicon} key={d1.companyName} onClick={() => this.deletePreferences(d1.companyName, d1.userEmail)} />
                                                                            </td>
                                                                        </tr>
                                                                    </>)
                                                                })
                                                            );
                                                        }))}
                                                    </table>
                                                </div>
                                            }
                                            {this.state.PartnerName === 'CnF Agents' &&
                                                <div>
                                                    <table class="PrefRTablecss">
                                                        {(this.state.CnFAgents?.map((CnFAgent, index) => {
                                                            return (
                                                                (CnFAgent?.dataList)?.map((d1, i) => {
                                                                    return (<>
                                                                        <tr class="PrefRTableRow">
                                                                            <td class="PrefRTablecol1">{i + 1}</td>
                                                                            <td class="PrefRTablecol2">{d1.companyName}</td>
                                                                            <td class="PrefRTablecol3" >
                                                                                <img class="PreferencesReqDelete_img" src={deleteicon} key={d1.companyName} onClick={() => this.deletePreferences(d1.companyName, d1.userEmail)} />
                                                                            </td>
                                                                        </tr>
                                                                    </>)
                                                                })
                                                            );
                                                        }))}
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.hasOpenPending ? <AddProfileModal hasOpen={this.state.hasOpenPending} onCloseModal={this.onClosePending} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{this.state.errorMessage}</small>
                        </div>
                    </div>
                </AddProfileModal> : null}
                <div class="PreferencesReqFooterUnfixed">
                    <Footer />
                </div>
                <div class="PreferencesReqFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        //
    }
}
export default connect(mapStateToProps)(RequesterPreferences);